import { Directive, ElementRef, afterRenderEffect, contentChildren, inject } from '@angular/core';

import { DeviceService } from '@frontend/vanilla/core';

@Directive({
    selector: '[msScrollTo]',
})
export class ScrollToDirective {
    private elm = inject(ElementRef);
    private deviceService = inject(DeviceService);

    items = contentChildren('msScrollToItem');

    element: HTMLElement;

    constructor() {
        this.element = this.elm.nativeElement;
        afterRenderEffect(() => {
            const orientation = this.deviceService.orientationSignal();
            if (orientation && this.items().length > 0) {
                this.changeScroll();
            }
        });
    }

    private changeScroll = (): void => {
        if (this.element.scrollWidth > this.element.offsetWidth) {
            this.element.scrollLeft = this.element.scrollWidth;
        }
    };
}
